import { connect, ConnectedProps } from 'react-redux';
import {
  getTourState,
  nextStep,
  setIsRunning,
  setRetryTarget,
  startTour,
  stopTour
} from 'slices/productOnboarding';
import { getIsDrawerMenuOpen, toggleDrawerMenu } from 'slices/drawerMenu';

import { RootState } from 'store/store';
import { ProductOnboarding } from 'components/_V2/ProductOnboarding/ProductOnboarding';
import { closeAccountSelector } from 'selectors/closeAccountSelector';
import { tenantSettingsSelector } from 'selectors/tenantSettingsSelector';
import { appSelector } from 'selectors/appSelectors';

const mapStateToProps = (state: RootState) => {
  const { isRunning, stepIndex, retryTarget } = getTourState(state);
  const { status: isAccountClosed } = closeAccountSelector(state);
  const { tenantSettings } = tenantSettingsSelector(state);
  const { isManualSwitch } = appSelector(state);
  const isDrawerMenuOpen = getIsDrawerMenuOpen(state);

  return {
    isRunning,
    stepIndex,
    retryTarget,
    isAccountClosed,
    tenantSettings,
    isManualSwitch,
    isDrawerMenuOpen
  };
};

const connector = connect(mapStateToProps, {
  startTour,
  setRetryTarget,
  stopTour,
  setIsRunning,
  nextStep,
  toggleDrawerMenu
});

export type ProductOnboardingPropsFromRedux = ConnectedProps<typeof connector>;

const ProductOnboardingContainer = connector(ProductOnboarding);

export default ProductOnboardingContainer;
